import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums';
import { ReactNode, useEffect, useMemo, useRef, useState } from 'react'
import { getAddress, isAddress } from 'viem'

import { classNames } from '../../../functions'
import useENSAddress from '../../../hooks/useENSAddress';
import { UserPlus, XCircleIcon } from '../../Icons'
import { DEFAULT_INPUT_UNSTYLED, Input } from '../../Input'

export type Props = { userExpertMode: boolean; recipientActive: boolean; chainId: number, isWrap: boolean } & {
  children:
    | ReactNode
    | Array<ReactNode>
    | ((
        _recipient: string | undefined
      ) => JSX.Element)
}

export const AddressInput = ({
  children,
  userExpertMode = false,
  recipientActive = false,
  chainId,
  isWrap,
  ...props
}: Props): JSX.Element => {
  const [query, setQuery] = useState<string>('')
  const inputRef = useRef<HTMLInputElement>(null)
  const { address: recipientAddress } = useENSAddress(query)
  const _recipient = useMemo(
    () =>
      query !== 'bch' && userExpertMode && recipientActive
        ? recipientAddress
          ? recipientAddress
          : query && isAddress(query)
          ? getAddress(query, chainId)
          : undefined
        : undefined,
    [chainId, query, recipientActive, recipientAddress, userExpertMode]
  )
  // reset recipient on removing receipient
  useEffect(() => {
    if (!recipientActive) {
      setQuery('')
    }
  }, [recipientActive])
  if (typeof children === 'function') {
    return (
      <>
        {recipientActive && userExpertMode && !isWrap && (
          <div
            className={classNames(
              'relative flex items-center justify-between gap-2 px-3 mx-4 mb-4 rounded-2xl py-2 text-primary bg-tokenselectorlist',
              !_recipient && query !== ''
                ? '!ring-2 !ring-red-500 focus:!ring-transparent focus-within:!ring-secondarybg  selection:'
                : _recipient
                ? '!ring-2 !ring-green-500'
                : 'focus-within:!ring-2 focus-within:!ring-secondarybg'
            )}
          >
            <Input.Address
              type="text"
              variant="unstyled"
              id="token-search"
              ref={inputRef}
              placeholder={`Add Recipient by Address or ${
                chainId === ChainId.SMARTBCH || ChainId.SMARTBCH_TESTNET ? `LNS` : `ENS`
              }`}
              value={query}
              onChange={setQuery}
              className={classNames(
                DEFAULT_INPUT_UNSTYLED,
                '!bg-transparent btn w-full flex group !text-primary  placeholder:text-slate-800 !font-medium  gap-2 cursor-pointer opacity-80 hover:opacity-100 hover:bg-opacity-70 px-4 h-[34px] rounded-xl text-base'
              )}
            />
            {query ? (
              <XCircleIcon
                width={20}
                height={20}
                className="cursor-pointer z-[10] text-slate-900 hover:text-slate-700"
                onClick={() => setQuery('')}
              />
            ) : (
              <UserPlus
                className="user-select-none pointer-events-none text-slate-600 fill-slate-600 z-[10]"
                strokeWidth={2}
                width={20}
                height={20}
              />
            )}
          </div>
        )}
        {children(_recipient)}
      </>
    )
  }

  return (
    <>
      {recipientActive && userExpertMode && !isWrap && (
        <Input.Address
          type="text"
          variant="unstyled"
          id="token-search"
          ref={inputRef}
          placeholder={`Add Recipient by Address or ${
            chainId === ChainId.SMARTBCH || ChainId.SMARTBCH_TESTNET ? `LNS` : `ENS`
          }`}
          value={query}
          onChange={setQuery}
          className={classNames(
            DEFAULT_INPUT_UNSTYLED,
            !_recipient && query !== ''
              ? '!ring-1 !ring-red-500 focus:!ring-transparent'
              : _recipient
              ? ' !ring-1 !ring-green-500'
              : '',
            ' bg-slate-500 btn w-full font-medium flex items-center justify-center gap-2 cursor-pointer opacity-80 hover:opacity-100 bg-primarybg  text-primary hover:bg-opacity-70 px-4 h-[34px] rounded-xl text-base'
          )}
        />
      )}
      {children}
    </>
  )
}
